import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';

export interface ServiceOwnersState {
  selectedOwnerBar: any | null;
  selectedTeamBar: any | null;
  selectedApiBar: any | null;
}

const initialState: ServiceOwnersState = {
  selectedOwnerBar: null,
  selectedTeamBar: null,
  selectedApiBar: null,
};

export const serviceOwnersSlice = createSlice({
  name: 'serviceOwners',
  initialState,
  reducers: {
    selectOwner: (state, action: PayloadAction<any | null>) => {
      state.selectedOwnerBar = action.payload;
      state.selectedTeamBar = null;
      state.selectedApiBar = null;
    },
    selectTeam: (state, action: PayloadAction<any | null>) => {
      state.selectedTeamBar = action.payload;
      state.selectedOwnerBar = null;
      state.selectedApiBar = null;
    },
    selectApi: (state, action: PayloadAction<any | null>) => {
      state.selectedApiBar = action.payload;
      state.selectedOwnerBar = null;
      state.selectedTeamBar = null;
    },
    clearAllSelections: state => {
      state.selectedOwnerBar = null;
      state.selectedTeamBar = null;
      state.selectedApiBar = null;
    },
  },
});
export const { selectOwner, selectTeam, selectApi, clearAllSelections } =
  serviceOwnersSlice.actions;
export const selectServiceOwnerState = (state: RootState) => state.serviceOwners;
export default serviceOwnersSlice.reducer;